import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { FamilyTariffModalProps } from 'reactApp/ui/FamilyTariffModal/FamilyTariffModalTypes';

export const renderFamilyTariffModal = ({ ...data }: FamilyTariffModalProps) =>
    openPopupHelper({
        popupName: popupNames.FAMILY_TARIFF_MODAL,
        data,
    });
